const assertUnreachable = (_x: unknown, error: string | Error): never => {
    if (typeof error === 'string') {
        throw Error(error);
    } else {
        throw error;
    }
};

export default assertUnreachable;
